var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.08301 4.26634L6.94967 1.84967C7.08301 1.6719 7.24134 1.54134 7.42467 1.45801C7.60801 1.37467 7.79967 1.33301 7.99967 1.33301C8.19967 1.33301 8.39134 1.37467 8.57468 1.45801C8.75801 1.54134 8.91634 1.6719 9.04967 1.84967L10.9163 4.26634L13.7497 5.21634C14.0386 5.30523 14.2663 5.46912 14.433 5.70801C14.5997 5.9469 14.683 6.21079 14.683 6.49967C14.683 6.63301 14.6636 6.76634 14.6247 6.89967C14.5858 7.03301 14.5219 7.16079 14.433 7.28301L12.5997 9.88301L12.6663 12.6163C12.6775 13.0052 12.5497 13.333 12.283 13.5997C12.0163 13.8663 11.7052 13.9997 11.3497 13.9997C11.3275 13.9997 11.2052 13.983 10.983 13.9497L7.99967 13.1163L5.01634 13.9497C4.96079 13.9719 4.89967 13.9858 4.83301 13.9913C4.76634 13.9969 4.70523 13.9997 4.64967 13.9997C4.29412 13.9997 3.98301 13.8663 3.71634 13.5997C3.44967 13.333 3.3219 13.0052 3.33301 12.6163L3.39967 9.86634L1.58301 7.28301C1.49412 7.16079 1.43023 7.03301 1.39134 6.89967C1.35245 6.76634 1.33301 6.63301 1.33301 6.49967C1.33301 6.2219 1.41356 5.96356 1.57467 5.72467C1.73579 5.48579 1.96079 5.31634 2.24967 5.21634L5.08301 4.26634Z",
    stroke: "var(--star-color, currentColor)",
    strokeWidth: 1,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIcon);
export default __webpack_public_path__ + "static/media/startIcon.48f68be3353e8287ba4ce5de0a69c64c.svg";
export { ForwardRef as ReactComponent };